import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormatted',
    standalone: true
})
export class DateFormatPipe implements PipeTransform {
    transform(date: Date | string | undefined): string {
        if (!date) return "";

        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    }
}